export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/faces/joe-gardner-2-76ff47ae5c64ccda5af18326bb272058.jpg";